import clientUtils from '../../Utils/clientUtils';
import { ApiHelper } from '../../common/ApiHelper';
import { InferenceResponse, InputInfo, OutcomeInfo } from '../../models/APIModels';
import { InputProps } from '../../models/type';

export default {
  generateInputs(inputs: InputInfo[], predictEngineType, variableDisplayOptions = {}) {
    let newInputs: InputProps[] = [];
    for (let i = 0; i < inputs.length; i++) {
      let newInput: InputProps = {};
      const inputName = inputs[i].name;
      newInput.description = inputs[i].inputDescription;
      newInput.name = inputName;
      newInput.placeholder = `Enter ${inputName}`;
      newInput.label = inputs[i].name;
      if (inputs[i].inputType === 'Integer') {
        newInput.type = 'text';
        newInput.typeValue = 'number';
        newInput.value = '';
      } else if (inputs[i].inputType === 'String') {
        newInput.type = 'text';
        newInput.typeValue = 'string';
        newInput.value = '';
        if (!clientUtils.isObjectEmpty(variableDisplayOptions)) {
          const keyName = clientUtils.uniqueKeyNameGenForVariableDisplayOptions(inputName, 'inputcon');
          newInput.isMultiline = variableDisplayOptions.hasOwnProperty(keyName)
            ? variableDisplayOptions[keyName].enableMultiLineText
            : false;

        }
      } else if (inputs[i].inputType === 'File') {
        newInput.type = 'file';
        newInput.typeValue = 'string';
        newInput.value = '';
        newInput.file = null;
        newInput.inputAction = 'Upload';
        newInput.placeholder = 'Upload a file';
        if (!clientUtils.isObjectEmpty(variableDisplayOptions)) {
          const keyName = clientUtils.uniqueKeyNameGenForVariableDisplayOptions(inputName, 'inputcon');
          newInput.imagePreviewEnabled = variableDisplayOptions.hasOwnProperty(keyName)
            ? variableDisplayOptions[keyName].enablePictureViewer
            : false;
        }
      }
      if (inputs[i].options && inputs[i].options.length > 0) {
        newInput.type = 'select';
        newInput.options = inputs[i].options.map((o) => {
          return {
            value: o.optionValue,
            type: o.optionType,
            optionFriendlyName: o.optionFriendlyName ? o.optionFriendlyName : o.optionValue,
          };
        });
      }
      newInput.validations = [];
      const validation = {
        type: 'required',
        message: `${inputs[i].name} is required.`,
      };
      if (predictEngineType !== 'AppEngine') {
        newInput.validations.push(validation);
      }
      if (newInput && newInput.type === 'file') {
        newInput.validations.push({
          type: 'required',
          message: `${inputs[i].name} is required.`,
        });
      }
      newInputs.push(newInput);
    }
    return newInputs;
  },
  generateOutcomes(outComes: OutcomeInfo[]) {
    let newOutComes: InputProps[] = [];

    for (let i = 0; i < outComes.length; i++) {
      let newInput: InputProps = {};
      newInput.description = outComes[i].outcomeDescription;
      newInput.name = outComes[i].name;
      newInput.placeholder = `Enter ${outComes[i].name}`;
      newInput.label = outComes[i].name;
      if (outComes[i].outcomeType === 'File') {
        newInput.type = 'file';
        newInput.typeValue = 'string';
        newInput.inputAction = 'Download';
        newInput.placeholder = '';
        newInput.value = '';
      } else {
        newInput.type = 'text';
        newInput.typeValue = 'string';
      }
      newInput.disabled = true;
      newInput.options = outComes[i].options;
      newOutComes.push(newInput);
    }
    return newOutComes;
  },
  // Initialize Inference with Model ID and get the requestId
  async initializeInference(model) {
    let response: InferenceResponse = null;
    try {
      if (model) {
        const { data, status } = await ApiHelper.InitializeInference(model.modelId);
        if (status === 200) {
          response = data;
          return data;
        }
        return response;
      }
    } catch (error) {
      console.log('Unable to initializeInference', { error });
      return response;
    }
  },
  async getUploadLinkForInference(reqId, fileName) {
    try {
      const uploadLinkRes = await ApiHelper.GetUploadLinkForInference(reqId, fileName);
      if (uploadLinkRes && uploadLinkRes.data) {
        return uploadLinkRes.data;
      }
      return null;
    } catch (error) {
      console.error('Unable to get upload link', { error });
      return null;
    }
  },
  chatBotIframeGenerator: (modelID) =>
    `<iframe src="${window.location.origin}/chatbot/${modelID}" style="height:100%;width:100%;"></iframe>`,
  async predictRun(modelId, payload) {},
};
